
































































import moment from 'moment';
import { Component, Ref, Vue } from 'vue-property-decorator';
import SensorsChoice from '@/components/staff/SensorsChoice.vue'; // @ is an alias to /src
import DateSelection from '@/components/staff/DateSelection.vue';
import DisplayOptions from '@/components/staff/DisplayOptions.vue';
import SensorInfo from '@/components/staff/SensorInfo.vue';
import InternalLineChart from '@/components/InternalLineChart.js';
import VueDygraph from '@/components/staff/VueDygraph.vue';

import axios from 'axios';
import VueAxios from 'vue-axios';
import { AxiosResponse } from 'axios';

interface ISensorData {
    headers: string[];
    values: any[][];
}

@Component({
    components: {
        SensorsChoice,
        DateSelection,
        DisplayOptions,
        SensorInfo,
        InternalLineChart,
        VueDygraph,
    },
})
export default class Data extends Vue {
    // @Ref() public readonly renderChart!: InternalLineChart;

    public $refs!: {
        renderChart: any;
    };


    // These coresppnd to what we pass to the backend. Ie the array positions can not change.
    // Has to match values in DataOptions
    private resolutions: any[] = [   {id: 0, name: 'All', factor: 1.0},
                                        {id: 2, name: '1 Minute', factor: 1.0 / 60.0},
                                        {id: 3, name: '5 Minute', factor: 1.0 / 60.0 / 5.0},
                                        {id: 4, name: '20 Minute', factor: 1.0 / 60.0 / 20.0},
                                        {id: 5, name: '30 Minute', factor: 1.0 / 60.0 / 30.0},
                                        {id: 6, name: '1 Hour', factor: 1.0 / 60.0 / 60.0},
                                        {id: 8, name: '1 Day', factor: 1.0 / 60.0 / 60.0 / 24.0},
                                        {id: 9, name: '1 Week', factor: 1.0 / 60.0 / 60.0 / 24.0 / 7.0},
                                        // {id: 10, name: 'Monthly (Linearly Interpolated)', factor: 1.0},
                                        // {id: 11, name: 'Monthly Rolling Average', factor: 1.0},
                                        // {id: 14, name: 'Monthly Rolling Sum', factor: 1.0},
                                        // {id: 12, name: 'Yearly', factor: 1.0},
                                   ];

    private action: number = -1;

    private data: any = {};
    private chartWidth: number = 100;
    private chartHeight: number = 200;

    private defaultStartDate: string | null = null;
    private defaultEndDate: string | null = null;

    private actions: object[] = [
        { id: 0, name: 'Plot Graph' },
        { id: 2, name: 'Export Graph Data' },
        { id: 3, name: 'Export Graph As Image' },
    ];

    public async mounted() {
        const self = this;
    }

    public async onActionPressed() {
        const self = this;

        self.defaultStartDate = self.$store.getters.StartDate;
        self.defaultEndDate = self.$store.getters.EndDate;

        self.data = await this.chartData();
    }

    // This function gets data but limited to a fixed amount.
    // If there is too much data we decrese the resolution on the data
    private getDataForRange(startDate: moment.Moment, endDate: moment.Moment, resolution: number): number {

        const self = this;
        const pointsPerDay = 60 * 60 * 24;  // Assume 1 point per minute (worst case)
        const daySpan = endDate.diff(startDate, 'days');

        // const currentResolutionIndex = self.resolutions.findIndex((element) => {
        //     return element.id === resolution;
        // });

        const currentResolutionIndex = 0;

        let points: number = daySpan * pointsPerDay * self.resolutions[currentResolutionIndex].factor * self.$store.getters.BmosIds.length;
        let index: number = currentResolutionIndex;

        while (points > 10000) {
            index++;
            points = daySpan * pointsPerDay * self.resolutions[index].factor;
        }

        this.$store.dispatch('setResolution', self.resolutions[index].id);
        return self.resolutions[index].id;
    }

    private async chartData(): Promise<any> {
        const self = this;

        const headers = {
            // 'Content-Type': 'application/json',
            // Accept: 'application/json',
            Authorization: 'Token ' + self.$store.getters.Jwt,
        };

        const interval = self.getDataForRange(moment(self.$store.getters.StartDate),
                                              moment(self.$store.getters.EndDate),
                                              self.$store.getters.Resolution);

        self.$refs.renderChart.setWaiting(true);

        return await axios
            .post(
                'https://shimmyplus-default-backend.carnegosystems.net/rest/sensor_data/',
                {
                    start_date: self.$store.getters.StartDate,
                    end_date: self.$store.getters.EndDate,
                    sensor_ids: self.$store.getters.BmosIds,
                    interval: self.$store.getters.Resolution,
                    aggregate: self.$store.getters.Aggregate,
                },
                { headers: headers },
            )
            .then((response: AxiosResponse<any>) => {

                // Data we get
                // headers
                // Array
                // 0: "time"
                // 1: "bi1900035_import_(611432)"
                // 2: "bi1900035_export_(611433)"

                // values
                // [["2020-04-01T00:01:00 UTC", [927.197998046875, 90.4020004272461]], ...]


                // Dygraphs native format
                // new Dygraph(document.getElementById("graphdiv2"),
                // [
                //     [ new Date("2009/07/12"), 100, 200 ],
                //     [ new Date("2009/07/19"), 150, 220 ]
                // ],
                // {
                //     labels: [ "x", "A", "B" ]
                // });

                const data: any[] = [];
                const labels: string[] = [];

                for (const h of response.data.headers) {
                    labels.push(h);
                }

                for (const i of response.data.values) {
                    const tmp = [moment(i[0], 'YYYY-MM-DDTHH:mm:ss UTC').toDate()];
                    tmp.push(...i[1]);
                    // const vals = i.slice(1);
                    // Array.prototype.push.apply(tmp, i[1]);
                    data.push(tmp);
                }

                self.$refs.renderChart.setData(labels, data);
                self.$refs.renderChart.setWaiting(false);

                return {
                    // labels: timestamps,
                    // datasets: datasets,
                };
            })
            .catch((error) => {
                self.$refs.renderChart.setWaiting(false);
                console.log(error);
                return {
                    content: 'unknown',
                    status: 'unknown',
                    description: 'unknown',
                };
            });
    }

    private handleResetZoom() {

        const self = this;

        if (self.defaultStartDate !== null && self.defaultEndDate !== null) {

            const promise1 = self.$store.dispatch('setStartDate', self.defaultStartDate);
            const promise2 = self.$store.dispatch('setEndDate', self.defaultEndDate);

            Promise.all([promise1, promise2]).then(() => {
                self.chartData();
            });
        }
    }

    private handleZoom(startDate: moment.Moment, endDate: moment.Moment) {

        const self = this;

        const startDateStr = startDate.format('YYYY-MM-DD');
        const endDateStr = endDate.format('YYYY-MM-DD');

        const promise1 = self.$store.dispatch('setStartDate', startDateStr);
        const promise2 = self.$store.dispatch('setEndDate', endDateStr);

        self.$refs.renderChart.clear();

        Promise.all([promise1, promise2]).then(() => {
            self.chartData();
        });
    }
}
